function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#F06D22;stroke-width:2;}\n\t.st1{fill:none;stroke:#F06D22;stroke-width:1.5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Group 17");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Press"
}, /*#__PURE__*/React.createElement("g", {
  id: "Press-4",
  transform: "translate(-1111.000000, -729.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(1124.000000, 742.000000) scale(1, -1) translate(-1124.000000, -742.000000) translate(1112.000000, 730.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "st0",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1",
  className: "st1",
  points: "6.8,11.3 12,6.1 17.2,11.3  "
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke-3",
  className: "st1",
  d: "M12,7.3v10.1"
}))));

var SvgArrowDownOrange = function SvgArrowDownOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down-orange.394c2d4f.svg";
export { ForwardRef as ReactComponent };